// General Settings

export const version = 1.0;
export const clientName = 'Viva Cruise';

export const env = 'PROD';

/* --------------------------------------------------- */

// Api Settings

export const apiUrl = 'https://api.viva-cruise.co.uk/api'

/* --------------------------------------------------- */

// Domain Settings

export const localUrl = 'localhost';

/* --------------------------------------------------- */

// Cloudinary Api Settings.
// Setup a Cloudinary account on behalf of the client.  Input the details here.

export const EAGER = [
  {
    width: 1000,
    height: 1000,
    crop: 'crop',
  },
];

export let cloudinaryApiKey = '394715672258859';
export let cloudinaryApiUploadPreset = 'efiw6rof';
export let cloudinarySecret = 'Seu-PbcKKbZ6YMQ9QEHLHfwiGk4';


/* --------------------------------------------------- */



// WEBPACK FOOTER //
// ./src/config/config.js